import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("re_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      // token invalid — clear it
      localStorage.removeItem("re_token");
    }
    return Promise.reject(err);
  }
);

export function fmtEur(cents) {
  return `${(cents / 100).toFixed(2).replace(".", ",")} €`;
}

export function classNames(...c) {
  return c.filter(Boolean).join(" ");
}
